"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notification = function Notification(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M18.75 16.1459C18.3358 16.1454 17.9386 15.9807 17.6457 15.6878C17.3528 15.3948 17.188 14.9977 17.1875 14.5834V10.4167C17.1875 7.83205 15.0847 5.72925 12.5 5.72925C9.91533 5.72925 7.81252 7.83205 7.81252 10.4167V14.5834C7.81205 14.9977 7.64728 15.3948 7.35436 15.6878C7.06143 15.9807 6.66428 16.1454 6.25002 16.1459C6.11189 16.1459 5.97941 16.2008 5.88174 16.2985C5.78406 16.3961 5.72919 16.5286 5.72919 16.6667C5.72919 16.8049 5.78406 16.9374 5.88174 17.035C5.97941 17.1327 6.11189 17.1876 6.25002 17.1876H9.94823C10.0683 17.7757 10.3879 18.3043 10.8529 18.684C11.3179 19.0636 11.8997 19.2709 12.5 19.2709C13.1003 19.2709 13.6822 19.0636 14.1471 18.684C14.6121 18.3043 14.9317 17.7757 15.0518 17.1876H18.75C18.8882 17.1876 19.0206 17.1327 19.1183 17.035C19.216 16.9374 19.2709 16.8049 19.2709 16.6667C19.2709 16.5286 19.216 16.3961 19.1183 16.2985C19.0206 16.2008 18.8882 16.1459 18.75 16.1459ZM8.85419 14.5834V10.4167C8.85419 9.44981 9.2383 8.52248 9.92203 7.83875C10.6058 7.15503 11.5331 6.77091 12.5 6.77091C13.467 6.77091 14.3943 7.15503 15.078 7.83875C15.7617 8.52248 16.1459 9.44981 16.1459 10.4167V14.5834C16.1453 15.1472 16.3286 15.6958 16.668 16.1459H8.33202C8.67146 15.6958 8.85479 15.1472 8.85419 14.5834ZM12.5 18.2292C12.177 18.2288 11.8621 18.1285 11.5984 17.942C11.3347 17.7555 11.1352 17.492 11.0272 17.1876H13.9728C13.8648 17.492 13.6653 17.7555 13.4016 17.942C13.1379 18.1285 12.823 18.2288 12.5 18.2292Z",
    fill: props.foregroundColor
  }));
};

Notification.defaultProps = {
  altText: "Notification",
  foregroundColor: "#2D5AB4"
};
Notification.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Notification;
exports.default = _default;